// Đối tượng không phải ảnh để xem — link ẩn danh còn mỗi chúng thì coi như ca không còn ảnh. Video / PDF vẫn tính là xem được.
const KHONG_PHAI_ANH = new Set(['SR', 'KO', 'PR', 'SEG', 'RTSTRUCT', 'RTPLAN', 'REG']);

export default function laAnhXemDuoc(displaySet: { unsupported?: boolean; Modality?: unknown }): boolean {
  return !displaySet.unsupported && !KHONG_PHAI_ANH.has(String(displaySet.Modality ?? '').toUpperCase());
}
